import { z } from 'zod'

export const DNSRecordSchema = z.object({
	record: z.string(),
	name: z.string(),
	type: z.string(),
	value: z.string(),
	ttl: z.union([z.string(), z.number()]).optional(),
	status: z.string().optional(),
	priority: z.number().optional(),
})

export const EmailDomainSchema = z.object({
	id: z.string(),
	domain: z.string(),
	status: z.string(),
	storeId: z.string().nullable(),
	fromEmail: z.string().nullable(),
	dnsRecords: z.array(DNSRecordSchema).nullable().optional(),
	externalDomainId: z.string().nullable(),
	verifiedAt: z.date().nullable().optional(),
	createdAt: z.date().nullable().optional(),
	updatedAt: z.date().nullable().optional(),
	accountId: z.string().nullable().optional(),
})

export type EmailDomainType = z.infer<typeof EmailDomainSchema>

export const toEmailDomainDto = (data: any): EmailDomainType => {
	return EmailDomainSchema.parse(data)
}

export const toEmailDomainListDto = (data: any[]): EmailDomainType[] => {
	return data.map(toEmailDomainDto)
}

